import { Injectable } from "@angular/core";
import { Messaging, getToken, onMessage, deleteToken, getMessaging } from "@angular/fire/messaging";
import { Observable, tap } from "rxjs";
import { onBackgroundMessage } from "firebase/messaging/sw";
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { FirebaseApp } from "@angular/fire/app";

@Injectable({ providedIn: 'root' })
export class PushService {
    static vapidKey:string = "BNxM1R56L-P0Hl7JusGTcNheXe_z_Q_SSGKYFOqPwmXQy2ws0WuXrL4IfbRk4btY3OTTil8ZtcawMh1imTycYgE";

    constructor(private afMessaging: AngularFireMessaging) {
            
        if ('serviceWorker' in navigator)  
            navigator.serviceWorker.register('./firebase-messaging-sw.js').then(registration => {
                console.log("service Worker ON");
        });
        
        Notification.requestPermission().then(
            (notificationPermissions: NotificationPermission) => {
                if (notificationPermissions === "granted") {
                    console.log("Granted");
                }
                if (notificationPermissions === "denied") {
                    console.log("Denied");
                }
            });
    }

    requestPermission = () => this.afMessaging.requestToken;

    deleteToken = (token: string) => this.afMessaging.deleteToken(token);

}